module.exports = __webpack_public_path__ + "assets/hoppa1.jpg?a84536d4375317655a7833cc179a3060";